import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Layers from "slotworks/graphics/layers/layers";
import { wrapIndex } from "slotworks/utils/collection-utils";
import Contract from "slotworks/utils/contracts/contract";
import Point from "slotworks/utils/geom/point";

export default class ReelComponent {

    public readonly index: number;
    public readonly size: number;

    public mask: PIXI.Sprite | PIXI.Graphics;
    public validLandSymbols: string[];

    private stopIndex: number;

    private symbols: SymbolComponent[];
    private hiddenSymbols: SymbolComponent[];

    private matrixLayer: Layers;
    private animationLayer: Layers;

    private visible: boolean = true;

    constructor(index: number, rows: number, reelstrip: string[], defaultStop: number = 0, matrixLayer: Layers, animationLayer: Layers) {

        this.matrixLayer = matrixLayer;
        this.animationLayer = animationLayer;

        this.index = index;
        this.size = rows;

        this.symbols = [];
        this.hiddenSymbols = [];

        for (let row = 1; row < rows + 1; row++) {
            const symbol = this.createSymbolComponent(new Point(index, row), this.matrixLayer, this.animationLayer);
            this.symbols.push(symbol);
        }

        this.resetSymbolPositions();
        this.jump(defaultStop, reelstrip);
    }

    protected createSymbolComponent(position: Point, matrixLayer: Layers, animationLayer: Layers): SymbolComponent {
        return new SymbolComponent(position, matrixLayer, animationLayer);
    }

    /**
     * Reset symbol positions to default positionRects defined in assetworks (symbol_x_y)
     */
    public resetSymbolPositions() {
        for (const symbol of this.symbols) {
            let positionRect;

            if (this.mask) {
                symbol.setMask(this.mask);
            }

            const x = symbol.gridPosition.x;
            const y = symbol.gridPosition.y;

            positionRect = this.matrixLayer.getPosition(`symbol_${x}_${y}`);

            symbol.setTransform(positionRect);
        }
    }

    public jump(index: number, reelstrip: string[]) {
        this.stopIndex = index;

        for (let i = 0; i < this.symbols.length; i++) {

            const symbol = this.symbols[i];
            const offsetIndex = this.stopIndex + i;

            const symbolId = wrapIndex(offsetIndex, reelstrip);

            symbol.setSymbol(symbolId);
        }
    }

    public spin() {
        for (const symbol of this.symbols.concat(this.hiddenSymbols)) {
            symbol.setMoving(true);
        }
        return Contract.empty();
    }

    public blur() {
        for (const symbol of this.symbols.concat(this.hiddenSymbols)) {
            symbol.setBlurred(true);
        }
    }

    public unblur() {
        for (const symbol of this.symbols.concat(this.hiddenSymbols)) {
            symbol.setBlurred(false);
        }
    }

    public land() {
        for (const symbol of this.symbols.concat(this.hiddenSymbols)) {
            symbol.setBlurred(false);
            symbol.setMoving(false);
        }
        return Contract.empty();
    }

    public setVisible(visible: boolean) {
        this.visible = visible;
    }

    public getVisible() {
        return this.visible;
    }

    public getSymbols() {
        return this.symbols;
    }

    public getSymbolAt(y: number) {
        return this.symbols[y];
    }

    public addHiddenSymbol(symbol: SymbolComponent) {
        this.hiddenSymbols.push(symbol);
    }

    public clearHiddenSymbols() {
        this.hiddenSymbols = [];
    }

    public getMatrixLayer() {
        return this.matrixLayer;
    }

    public getAnimationLayer() {
        return this.animationLayer;
    }
}
